import { render, staticRenderFns } from "./TextChar.vue?vue&type=template&id=6f1ff713&scoped=true"
import script from "./TextChar.vue?vue&type=script&lang=js"
export * from "./TextChar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1ff713",
  null
  
)

export default component.exports